import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=64a52d7b&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=js&"
export * from "./Activities.vue?vue&type=script&lang=js&"
import style1 from "./Activities.vue?vue&type=style&index=1&id=64a52d7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a52d7b",
  null
  
)

export default component.exports